import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import InvitedIntake from "@/pages/InvitedIntake";
import TrialInfo from "@/pages/TrialInfo";
import Operator from "@/pages/Operator";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/start" element={<InvitedIntake />} />
          {/* Legacy routes redirect straight to the intake — no gate, no lookup */}
          <Route path="/invited/:legacySlug" element={<Navigate to="/start" replace />} />
          <Route
            path="/cierge-design-studio/invited/:legacySlug"
            element={<Navigate to="/start" replace />}
          />
          <Route path="/privacy" element={<TrialInfo page="privacy" />} />
          <Route path="/terms" element={<TrialInfo page="terms" />} />
          <Route path="/contact" element={<TrialInfo page="contact" />} />
          <Route path="/operator" element={<Operator />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
